import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';
import HomePage from './pages/HomePage';
import NewsListPage from './pages/NewsListPage';
import NewsDetailPage from './pages/NewsDetailPage';
import EventsPage from './pages/EventsPage';
import EventDetailPage from './pages/EventDetailPage';
import { MinistriesListPage, MinistryDetailPage } from './pages/MinistryPages';
import GovernmentPage from './pages/GovernmentPage';
import {
  InvestmentOpportunitiesPage,
  InvestmentSectorPage
} from './pages/InvestmentPages';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import DocumentsPage from './pages/DocumentsPage';
import { AuthProvider } from './lib/AuthContext';
import { SiteDataProvider } from './lib/SiteDataContext';
import { LanguageProvider, TranslatedSiteDataProvider } from './lib/LanguageContext';
import AdminLayout from './components/admin/AdminLayout';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminSlides from './pages/admin/AdminSlides';
import AdminNews from './pages/admin/AdminNews';
import AdminEvents from './pages/admin/AdminEvents';
import { AdminMinistries, AdminInvestment } from './pages/admin/AdminCrud';
import AdminSettings from './pages/admin/AdminSettings';
import AdminPassword from './pages/admin/AdminPassword';
import AdminDocuments from './pages/admin/AdminDocuments';

const PublicShell = ({ children }) => {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');
  if (isAdmin) return children;
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
      <CookieBanner />
    </>
  );
};

const PublicRoutes = () => (
  <SiteDataProvider>
    <LanguageProvider>
      <TranslatedSiteDataProvider>
        <PublicShell>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/news" element={<NewsListPage />} />
            <Route path="/news/:id" element={<NewsDetailPage />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/events/:id" element={<EventDetailPage />} />
            <Route path="/ministries" element={<MinistriesListPage />} />
            <Route path="/ministries/:slug" element={<MinistryDetailPage />} />
            <Route path="/government/:slug" element={<GovernmentPage />} />
            <Route path="/investment/opportunities" element={<InvestmentOpportunitiesPage />} />
            <Route path="/investment/:slug" element={<InvestmentSectorPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/about/:slug" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/documents" element={<DocumentsPage />} />
            <Route path="/documents/:category" element={<DocumentsPage />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
        </PublicShell>
      </TranslatedSiteDataProvider>
    </LanguageProvider>
  </SiteDataProvider>
);

function App() {
  return (
    <HelmetProvider>
      <div className="App min-h-screen bg-white text-[#0B2545]">
        <BrowserRouter>
          <AuthProvider>
            <Routes>
              {/* Admin */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="slides" element={<AdminSlides />} />
                <Route path="news" element={<AdminNews />} />
                <Route path="events" element={<AdminEvents />} />
                <Route path="ministries" element={<AdminMinistries />} />
                <Route path="investment" element={<AdminInvestment />} />
                <Route path="documents" element={<AdminDocuments />} />
                <Route path="settings" element={<AdminSettings />} />
                <Route path="password" element={<AdminPassword />} />
              </Route>
              {/* Public */}
              <Route path="/*" element={<PublicRoutes />} />
            </Routes>
          </AuthProvider>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
